const {
  cloneDeep
} = require('lodash');
const {
  evaluateSource
} = require('../lib/evaluateSource');
const {
  setPathFragment
} = require('../lib/common');
/**
  * @function evalute - evaluate setPathFragmentBehavior
  */
const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const object = await evaluateSource(source.object, content, parentContentPath, transientContext, nativeFunctions);
  if (object === undefined) {
    return undefined;
  }
  const path = await evaluateSource(source.path, content, parentContentPath, transientContext, nativeFunctions);
  if (path === undefined) {
    return undefined;
  }
  const value = await evaluateSource(source.value, content, parentContentPath, transientContext, nativeFunctions);
  if (value === undefined) {
    return undefined;
  }
  const objectCopy = cloneDeep(object);
  setPathFragment(objectCopy, path, value);
  return objectCopy;
};
module.exports = {
  evaluate
};